import React from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";

// Components
import Header from "../Header/Header";
import Card from "../Card/Card";
import Footer from "../Footer/Footer";

// Utils
import { GET_SUPPORT_REQUESTS } from "./Support.queries";

// Types
import { SupportRequest } from "../../types/Support.types";

// Styles
import "./Support.scss";

const QUERY_SUPPORT_REQUESTS = gql`
  ${GET_SUPPORT_REQUESTS}
`;

const Support: React.FC = () => {
  const [supportRequests, setSupportRequests] = React.useState<
    SupportRequest[]
  >([]);
  const [meta, setMeta] = React.useState({
    headline: "",
    description: "",
  });

  const handleComplete = (data: any) => {
    if (data) {
      const { supportRequests: requests } = data;
      const {
        descriptionCategories: supportDescription,
        headline: supportHeadline,
      } = data.sonnenEinstellungen.textSettings.support;

      setMeta({
        headline: supportHeadline,
        description: supportDescription,
      });
      setSupportRequests(requests);
    }
  };

  const { error } = useQuery(QUERY_SUPPORT_REQUESTS, {
    onCompleted: handleComplete,
  });

  if (error) {
    console.error(`[Support] ${error.message}`);
  }

  return (
    <div className="page-support">
      <Header />
      <div className="container">
        <div className="row my-4">
          <div className="col col-sm-6">
            <h1>{meta.headline}</h1>
            <p>{meta.description}</p>
          </div>
        </div>
        <div className="row">
          <div className="cardContainer">
            {supportRequests.map((request: SupportRequest) => (
              <div className="col col-sm-4" key={request.slug}>
                <Card
                  title={request.title}
                  href={request.link}
                  text={request.description}
                  externalLink={true}
                  image={{
                    src: request.iconSrc,
                    altText: request.iconAltText,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Support;
